unit GAS.Enumerations;

interface

{$IFDEF SPHINX}
uses  Aurelius.Mapping.Attributes;
{$ENDIF}

{$SCOPEDENUMS ON}

type

  {$IFDEF SPHINX}[Enumeration(TEnumMappingType.emString, 'None,FixedFee,Percentage')]{$ENDIF}
  TLicenseType = (None, FixedFee, Percentage);

  {$IFDEF SPHINX}[Enumeration(TEnumMappingType.emString, 'None,Monthly,Annual')]{$ENDIF}
  TFixedFeePeriod = (None, Monthly, Annual);

  {$IFDEF SPHINX}[Enumeration(TEnumMappingType.emString, 'Pending,Trial,Active,Suspended,Deleted,Admin')]{$ENDIF}
  TOrganisationStatus = (
    /// <summary>
    /// Initial setup in process
    /// </summary>
    Pending, Trial,
    /// <summary>
    /// Available
    /// </summary>
    Active, Suspended,
    /// <summary>
    /// No longer exists
    /// </summary>
    Deleted, Admin);

  {$IFDEF SPHINX}[Enumeration(TEnumMappingType.emString, 'Unknown,Standard,Agent,Admin')]{$ENDIF}
  TOrganisationKind = (Unknown, Standard, Agent, Admin);

  {$IFDEF SPHINX}[Enumeration(TEnumMappingType.emString,
    'System,Pending,Inactive,Active,Left,Retired,Suspended,Deleted,NotExists,Deceased')]{$ENDIF}
  TUserStatus = (System, Pending, Inactive, Active, Left, Retired, Suspended, Deleted, NotExists, Deceased);

  {$IFDEF SPHINX}[Enumeration(TEnumMappingType.emString, 'App,Email,SMS')]{$ENDIF}
  TMFAPreference = (App, Email, SMS);

  {$IFDEF SPHINX}[Enumeration(TEnumMappingType.emString, 'AsAgent,AsCharity')]{$ENDIF}
  TAgentSubmissionType = (AsAgent, AsCharity);


const
//CRM Levels
CRM_None = 0;
CRM_Basic = 1;
CRM_Advanced = 3;
CRM_Enterprise = 5;

implementation


{$SCOPEDENUMS OFF}

end.
